import React, { useState, useEffect, useContext } from "react";
import { formatDateTime } from "../../../helpers/helpers";
import peij from "../../../services/peij";
import AppContext from "../../../container/context";
import ActionTable from "../../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";

const Lista = ({ history }) => {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [promocoes, setPromocoes] = useState([]);

  useEffect(() => {
    listar();
  }, []);

  const listar = () => {
    setCarregando(true);

    peij
      .post("assinaturas/listarPromocoes")
      .then((res) => {
        res.forEach((p) => (p.validade = formatDateTime(p.validade, "D/M/Y")));
        setPromocoes(res);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", "Não foi possível listar os planos");
        setCarregando(false);
      });
  };

  const tRegistros = {
    title: "Promoções",
    array: promocoes,
    columns: [
      {
        name: "chave",
        label: "Chave",
      },
      {
        name: "valor",
        label: "Valor",
      },
      {
        name: "qtdParcelas",
        label: "Qtd. Parcelas",
      },
      {
        name: "validade",
        label: "Validade",
      },
    ],
    key: "chave",
    newItemAction: () => history.push("/app/promocao-ij/0"),
    onLineClick: (chave) => history.push(`/app/promocao-ij/${chave}`),
  };

  return (
    <div>
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          <ActionTable structure={tRegistros} />
        </>
      )}
    </div>
  );
};

export default Lista;
